import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";
import { IKizDTO, IKizStatusDTO, IKizViewDTO, IParsedBarcode, IKizStatusMoveErrorDTO, IKizStatusMoveErrorInDTO, IkizDocumentItemGtinDto, IKizSetTrustedDTO } from "../../coreapi-dto/dirs/kiz";
import { IDocumentInfoDTO } from "../../coreapi-dto/@types/common";
import { IKizOsuEditDTO } from "../../coreapi-dto/dirs/KizOsu";


class KizRequest extends BaseDirRequest<IKizViewDTO, IKizDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "Kiz", token, eventHandler)
    }

    kisOsuAsync(idDocumentItemGlobal: string, dto: IKizOsuEditDTO, callback?: (response) => void) {
        this.put(`${this._baseUrl}/${this._routePrefix}/KizOsu/${idDocumentItemGlobal}`, dto, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    getKizViewAsync(idDocument: string, body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<IKizViewDTO>>) => void, testApi?: ({ name, time }) => void) {
        const startTime = new Date().getTime();
        this.post<IViewWrapper<IKizViewDTO>>(`${this._baseUrl}/${this._routePrefix}/view/${idDocument}`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
            testApi?.({ name: `${this._routePrefix}/view`, time: new Date().getTime() - startTime })
        })
    }

    getKizViewInventorySvedAsync(idDocument: string, body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<IKizViewDTO>>) => void, testApi?: ({ name, time }) => void) {
        const startTime = new Date().getTime();
        this.post<IViewWrapper<IKizViewDTO>>(`${this._baseUrl}/${this._routePrefix}/viewByInventorySved/${idDocument}`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
            testApi?.({ name: `${this._routePrefix}/view`, time: new Date().getTime() - startTime })
        })
    }

    getKizByItem(idDocument: string, idDocumentItem: string, body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<IKizViewDTO>>) => void, testApi?: ({ name, time }) => void) {
        const startTime = new Date().getTime();
        this.post<IViewWrapper<IKizViewDTO>>(`${this._baseUrl}/${this._routePrefix}/view/${idDocument}/item/${idDocumentItem}`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
            testApi?.({ name: `${this._routePrefix}/view/${idDocument}/item/${idDocumentItem}`, time: new Date().getTime() - startTime })
        })
    }

    getKizBySscc(sscc: string, callback?: (e: CoreApiResponse<IKizDTO[]>) => void) {
        this.get<IKizDTO[]>(`${this._baseUrl}/${this._routePrefix}/GetBySscc/${sscc}`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    getKizStatus(barcode: string, callback?: (e: CoreApiResponse<IKizStatusDTO>) => void) {
        this.post<IKizStatusDTO>(`${this._baseUrl}/${this._routePrefix}/Status/${barcode}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e: CoreApiResponse<IKizStatusDTO>) => {
            callback?.(e);
        })
    }

    parse(barcode: string, callback: (e: CoreApiResponse<IParsedBarcode>) => void): void {
        this.post<IParsedBarcode>(`${this._baseUrl}/${this._routePrefix}/Parse/${barcode}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e: CoreApiResponse<IParsedBarcode>) => {
            callback(e);
        })
    }

    parseBoxGisMt(barcode: string, type: string, callback: (e: CoreApiResponse<IParsedBarcode>) => void): void {
        this.post<IParsedBarcode>(`${this._baseUrl}/${this._routePrefix}/Parse/${barcode}/${type}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e: CoreApiResponse<IParsedBarcode>) => {
            callback(e);
        })
    }

    getKizStatusMoveError(barcode: string, idDocument: string, callback?: (e: CoreApiResponse<IKizStatusMoveErrorDTO>) => void) {
        this.get<IKizStatusMoveErrorDTO>(`${this._baseUrl}/${this._routePrefix}/StatusMoveError/${barcode}/${idDocument}`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e: CoreApiResponse<IKizStatusMoveErrorDTO>) => {
            callback?.(e);
        })
    }

    getKizStatusMoveErrors(dto: IKizStatusMoveErrorInDTO, callback?: (e: CoreApiResponse<IKizStatusMoveErrorDTO[]>) => void) {
        this.post<IKizStatusMoveErrorDTO[]>(`${this._baseUrl}/${this._routePrefix}/StatusMoveErrors`, dto, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e: CoreApiResponse<IKizStatusMoveErrorDTO[]>) => {
            callback?.(e);
        })
    }

    getIdDocumentItemByGtin(barcode: string, document: IDocumentInfoDTO, idLotGlobal: string, callback?: (e: CoreApiResponse<IkizDocumentItemGtinDto>) => void) {
        this.get<IkizDocumentItemGtinDto>(`${this._baseUrl}/${this._routePrefix}/GetIdDocumentItemByGtin/${barcode}/${document.idDocument}/${document.idTable}/${idLotGlobal}`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e: CoreApiResponse<IkizDocumentItemGtinDto>) => {
            callback?.(e);
        })
    }

    saveRawBarcode(idKizGlobal: string, rawBarcodeBase64: string, callback?: (e: CoreApiResponse<boolean>) => void): void {
        this.patch2(`${this._baseUrl}/${this._routePrefix}/${idKizGlobal}/SaveRawBarcode/${rawBarcodeBase64}`, null,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e: CoreApiResponse<boolean | null>) => {
                if (this._eventHandler) {
                    this._eventHandler.onGetResponse(e)
                }
                callback?.(e as CoreApiResponse<boolean>);
            })
    }

    setTrusted(idKizGlobal: string, isTrusted: boolean, callback?: (e: CoreApiResponse<boolean>) => void): void {
        this.patch2(`${this._baseUrl}/${this._routePrefix}/${idKizGlobal}/IsTrusted`, { isTrusted: isTrusted } as IKizSetTrustedDTO,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e: CoreApiResponse<boolean | null>) => {
                if (this._eventHandler) {
                    this._eventHandler.onGetResponse(e)
                }
                callback?.(e as CoreApiResponse<boolean>);
            })
    }

    setTrustedForParent(idParent: string, isTrusted: boolean, callback?: (e: CoreApiResponse<boolean>) => void): void {
        this.patch2(`${this._baseUrl}/${this._routePrefix}/Parent/${idParent}/IsTrusted`, { isTrusted: isTrusted } as IKizSetTrustedDTO,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e: CoreApiResponse<boolean | null>) => {
                if (this._eventHandler) {
                    this._eventHandler.onGetResponse(e)
                }
                callback?.(e as CoreApiResponse<boolean>);
            })
    }

    searchByGtinSgtin(gtinSgtin: string, callback?: (e: CoreApiResponse<IKizDTO>) => void) {
        const encodedGtinSgtin = encodeURIComponent(gtinSgtin);
        this.get<IKizDTO>(
            `${this._baseUrl}/${this._routePrefix}/SearchByGtinSgtin/${encodedGtinSgtin}`,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e: CoreApiResponse<IKizDTO>) => {
                callback?.(e);
            }
        );
    }

    checkSgtins(idDocumentGlobal: string, callback?: (e: CoreApiResponse<any>) => void) {
    this.post<any>(
        `${this._baseUrl}/${this._routePrefix}/CheckSgtins`,
        idDocumentGlobal,
        this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
        callback
    );
    }

    getCheckSgtinsResult(taskId: string, idDocumentGlobal: string, callback?: (e: CoreApiResponse<any>) => void) {
    this.get<any>(
        `${this._baseUrl}/${this._routePrefix}/CheckSgtinsResult/${taskId}/${idDocumentGlobal}`,
        this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
        callback
    );
    }

    removeInvalidKizs(idDocumentGlobal: string, body: { invalidSgtins: string[] }, callback?: (e: CoreApiResponse<null>) => void) {
    this.post<null>(
        `${this._baseUrl}/${this._routePrefix}/${idDocumentGlobal}/RemoveInvalidKizs`,
        body,
        this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
        (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e);
            }
            callback?.(e);
        }
    );
    }

    logIgnoreCheck(idDocumentGlobal: string, callback?: (e: CoreApiResponse<null>) => void) {
    
    const url = `${this._baseUrl}/${this._routePrefix}/${idDocumentGlobal}/LogIgnoreCheck`;
    const headers = this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]);
    
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': headers[0][1] || ''
        },
        body: null
    })
    .then(async response => {
        const contentType = response.headers.get('content-type');
        
        if (response.status === 204 || response.status === 200) {
            callback?.({
                respType: "isCompleted",
                data: null
            } as CoreApiResponse<null>);
            return;
        }
        
        if (contentType && contentType.includes('application/json')) {
            const data = await response.json();
            callback?.({
                respType: "isCompleted",
                data: data
            } as CoreApiResponse<null>);
        } else {
            callback?.({
                respType: "isCompleted",
                data: null
            } as CoreApiResponse<null>);
        }
    })
    .catch(error => {
        callback?.({
            respType: "isFailed",
            message: { title: error.message }
        } as CoreApiResponse<null>);
    });
    }
}

export default KizRequest